<div class="flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-auto min-w-0">
  <div
    class="md:flex md:items-start md:justify-end w-full sm:w-auto md:h-full md:w-1/2 py-8 px-4 sm:p-12 md:p-16 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none sm:bg-card">
    <auth-sign-in></auth-sign-in>
  </div>
  <div
    class="md:flex md:items-start md:justify-start w-full sm:w-auto md:h-full md:w-1/2 py-8 px-4 sm:p-12 md:p-16 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none bg-gray-800 dark:border-l">
    <auth-sign-up></auth-sign-up>
  </div>
</div>